import ApplicationController from '../application_controller';

/* global $ */
export default class extends ApplicationController {
  connect() {
    $(this.element).find('#guarda-banco').on('click', () => {
      // Al hacer click en guardar oculto el area que estaba desplegada
      const $elemento = $('#crear-banco');
      $elemento.attr('aria-expanded', 'false');
      $elemento.toggleClass('in');
    });
  }
}
